var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestDataCreationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9458_59499",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 46.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9458_59499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 35.5448C10.1359 35.5448 9.44082 35.2483 8.86433 34.6553C8.28811 34.062 8 33.3467 8 32.5094V10.0354C8 9.19809 8.28811 8.48279 8.86433 7.88951C9.44082 7.2965 10.1359 7 10.9495 7H32.7874C33.601 7 34.296 7.2965 34.8725 7.88951C35.4487 8.48279 35.7368 9.19809 35.7368 10.0354V20.6558C35.3352 20.4792 34.933 20.3296 34.5303 20.207C34.1276 20.0842 33.714 19.9862 33.2895 19.9132V10.0354C33.2895 9.90611 33.2371 9.78774 33.1324 9.68027C33.028 9.57253 32.913 9.51866 32.7874 9.51866H10.9495C10.8239 9.51866 10.7088 9.57253 10.6044 9.68027C10.4997 9.78774 10.4474 9.90611 10.4474 10.0354V32.5094C10.4474 32.6387 10.4997 32.7571 10.6044 32.8645C10.7088 32.9723 10.8239 33.0262 10.9495 33.0262H20.5069C20.5675 33.491 20.6574 33.9306 20.7765 34.3451C20.8959 34.7596 21.0412 35.1595 21.2125 35.5448H10.9495ZM10.4474 33.0262V9.51866V19.9132V19.7872V33.0262ZM14.1184 29.0542H20.6729C20.7441 28.6174 20.8498 28.1917 20.9898 27.7773C21.1301 27.3628 21.2828 26.949 21.4479 26.536H14.1184V29.0542ZM14.1184 22.5317H24.4634C25.1661 21.9183 25.916 21.4044 26.713 20.9899C27.51 20.5754 28.3635 20.281 29.2733 20.1067V20.0131H14.1184V22.5317ZM14.1184 16.0088H29.6184V13.4906H14.1184V16.0088ZM31.6579 39C29.6206 39 27.8876 38.2648 26.4589 36.7945C25.0301 35.3242 24.3158 33.5407 24.3158 31.444C24.3158 29.3474 25.0301 27.5639 26.4589 26.0935C27.8876 24.6232 29.6206 23.888 31.6579 23.888C33.6952 23.888 35.4282 24.6232 36.8569 26.0935C38.2856 27.5639 39 29.3474 39 31.444C39 33.5407 38.2856 35.3242 36.8569 36.7945C35.4282 38.2648 33.6952 39 31.6579 39ZM30.9363 36.3844H32.3795V32.1866H36.4584V30.7014H32.3795V26.5037H30.9363V30.7014H26.8574V32.1866H30.9363V36.3844Z",
    fill: "#3ECF3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDataCreationIcon);
export default __webpack_public_path__ + "static/media/testDataCreationIcon.8ba48fc02d98ca108a5087f35b80e2d7.svg";
export { ForwardRef as ReactComponent };